<template>
  <v-row>
    <v-col cols="12">
      <v-divider />
    </v-col>
  </v-row>
</template>